<template>
  <div
    class="prompt"
    :class="{
      'rounded-l left': position === 'left',
      'rounded-r right': position === 'right',
    }"
    v-tooltip="text"
  >
    <div
      class="connect-line animate__animated animate__fadeInLeft"
      v-if="position === 'left' && showAnswer && !hideConnect"
      :style="{
        'background-color': color,
      }"
    ></div>
    <div class="justify-center h-18 d-flex">
      <span
        v-if="position === 'right'"
        class="items-center justify-center flex-shrink-0 font-bold
         rounded-l w-9 d-flex text-base-0 horizontal layout center"
        :style="{
          'background-color': showAnswerColor ? color : '#B4BCCF',
        }"
      >
        {{ order }}
      </span>
      <div
        class="flex-grow border-t border-b horizontal layout center content"
        :class="{
          'border-l rounded-l': position === 'left',
          'border-r rounded-r': position === 'right',
        }"
        :style="{
          'background-color': bgWithTextColor,
          'border-color': showAnswerColor || position === 'left' ? color : '#B4BCCF',
        }"
      >
        <span>{{ text }}</span>
      </div>

      <span
        v-if="position === 'left'"
        class="items-center justify-center flex-shrink-0 font-bold
          rounded-r w-9 d-flex text-base-0 horizontal layout center"
        :style="{
          'background-color': color,
        }"
      >
        {{ index }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    position: {
      type: String,
      default: 'left',
    },
    order: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#B4BCCF',
    },
    bgColor: {
      type: String,
      default: 'transparent',
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
    showAnswerColor: {
      type: Boolean,
      default: false,
    },
    hideConnect: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    bgWithTextColor() {
      if (this.slideActive.textColour === '#ffffff') {
        return 'rgba(0, 0, 0, 0.7)'
      }
      return 'rgba(255, 255, 255, 0.85)'
    },
  },
}
</script>

<style lang="scss" scoped>
.prompt {
  margin: 16px;
  position: relative;

  &.left {
    margin-right: 24px;
  }
  &.right {
    margin-left: 24px;
  }

  .content {
    overflow: hidden;
    display: inline-flex;
    padding: 11px 10px;
    span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-align: center;
      -webkit-box-orient: vertical;
      line-height: 2rem;
    }
  }
  .connect-line {
    content: "";
    height: 4px;
    width: 28px;
    position: absolute;
    right: -39px;
    top: 33px;
    border-radius: 2px;
  }
}
</style>
